const en_US = {
    header:{
        home:'Home',
        create:'Create',
        benefits:'Writer Benefits',
        lang: 'Language'
    },
    login:{
        loginbtn: 'Login',
        logoutbtn: 'Logout',
        fblogin:'Sign In With Facebook',
        googlelogin:'Sign In With Google',
    },
    footer:{
        lianxi: 'Contact Us',
        tiaokuan: 'Terms Of Use',
        yinsi: 'Privacy Policy',
        xiazai: 'Download App',
    },
    create:{
        size: 'Cover size：400*560',
        file: 'File format：.jpg .png',
        upload: 'UPLOAD',
        title: 'Novel Information',
        skip: 'SKIP',
        bookTitle: 'Book Title',
        bookTitlePlace: 'Within 30 characters',
        genre: 'Genre',
        genrePlace: 'Please Select Genre',
        editor: 'Editor',
        editorPlace: 'If the editor(AE)\'s has helped us submit your book for our review, please choose her name. If not, please select \'none\'.',
        contractType: 'Contract Type',
        targetAudience: 'Target Audience',
        girl: 'Female',
        boy: 'Male',
        synopsis: 'Synopsis',
        description: 'Please write a description for your story with 20 to 300 words.',
        descriptionInfo: 'Please do not fill in the information irrelevant to the work.',
        tags: 'Tags',
        tagsPlace: 'Please select at least 3 tags for your story.',
        tagsTips: 'Select labels from the list (up to 5).',
        leavinglost:'Content changed after leaving the page will be lost!',
        edit: 'EDIT',
    },
    authorCenter:{
        stories:{
            title: 'Stories',
            chapters:'Chapters',
            words: 'Words',
            status:'Status',
            newChapters:'New Chapter',
            noStory:'No story',
            newStory:'New Story',
            chapterList:'Chapter List',
            editStory:'Edit Story',
            secondaryTitle:['Chapter list','Apply for contract','Apply for completion','Apply for bonus','Delete the story'],
            dujia:'Exclusive',
            feidujia:'Non-exclusive',
            // 章节页面所有
            noChapter:'No Chapter',
            Published: 'Published',
            Draft: 'Draft',
            // 新建章节
            newChapterPlace:[
                'Chapter Title. eg: Chapter 1 Introduction.',
                'A minimum of 1 words each chapter, and maximum 3,000 words',
                'Please enter at most 30 words',
                'Works Profile can not be less than 30 words',
                'Please fill in your email address so that we can contact you if your book is approved.',
                'email is not a valid email',
                'Are you sure to delete the chapter?'
            ],
            newChapterBtn:['Save','Publish','Delete'],
            publishChapter:['Automatically upload your chapters', 'Publish schedule', 'Now', 'Later'],
            confirm: 'Confirm',
            cancel: 'Cancel',
            review: 'Review',
            submit: 'Submit',
            success: 'Success',
            submitted:'Submitted',
            infoTips: 'INFORMATION TIPS',
            chPenName: 'Your Pen Name (Chinese)',
            // 签约合同
            contractLabel: [
                'Your Official Name',
                'Your Pen Name (English)',
                'Email',
                'Address',
                'Bank Account Type',
                'Bank Name',
                'Swift',
                'Account Number',
                'Whatsapp',
                'Front of ID card/ Passport',
                'Country',
                'Branch Code',
                'Phone number',
                'Please add your area code, e.g.,+917111111111',
                'Bank card',
                'Your Postal Code',
                'Bank Address',
                'Bank Branch Code',
                'Bank Postal Code',
                'Whether to settle in local currency',
                'self',
                'dollar',
                'Reverse of ID card',
                'Bank Routing Number',
            ],
            contractPlace:[
                'Must fill in Email',
                'Must fill in Bank Of Deposit',
                'Must fill in Address',
                'Must fill in Swift',
                'Must fill in Your Official Name',
                'Must fill in Your Pen Name',
                'Must fill in Account Type',
                'Must fill in Whatsapp',
                'Must fill in Phone number',
                'Must fill in ID Card/ Passport',
                'Must fill in Account Number',
                'Must fill in Country',
                'Your contract type is: ',
                'If incorrect, please click',
                'here',
                'to edit your contract type.',
                'Must fill in Bank Address',
                'Must fill in Bank Branch Code',
                'Must fill in Bank Postal Code',
                'Must fill in Your Postal Code',
                'Please choose whether to settle in local currency',
            ],
            contractSign:['Note','Under Review','Review Contract'],
            // 作品完结
            completing:[
                'You have only one chance to apply for completion for each story.After the status is changed, you can\'t release new chapters anymore. Are sure to apply for completion?',
                'Are sure to apply for completion?',],
            // 奖励
            rewards:[
                'You can apply for the Signing Bonus only when each signed novel reached 10k words. The bonus will be added to your account later.'
            ],
            // 删除
            deleteStory:[
                'Only unpublished stories could be deleted, and the deleted story couldn\'t be restored.',
                'Are you sure to delete this work? Cannot recover after deletion.'
            ],
        },
        income:{
            title: 'Income',
            Totalincome: 'Total income',
            Search: 'Search',
            rules: ' Withdrawal Rules:<br>\n' +
                '              1. You will start to earn revenue once you have become a signed Author.<br>\n' +
                '              2. You will be able to withdraw your wallet’s income once your balance has reached $100.<br>\n' +
                '              3. The taxes and the fees incurred by the payment shall be borne by the author according to the policy of the payment channel.<br>\n' +
                '              4. Withdrawal request can only be done once a month.<br>\n' +
                '              5. You can withdraw from the 5th to the 7th of each month(UTC/GMT+08:00). And the money will be sent to your account no later than the 20th of each month(Normally it\'s by every 15th.)',
            NoIncome:'No Income',
            withdrawalBtn:[
                'Apply for withdrawal',
                'Waiting for Approval',
                'Approved',],
            withdrawalTable:[
                'Time','Income type'
            ],
        },
        inbox:{
            title:'Inbox',
            System: 'System',
            NoInbox:'No Inbox'
        },
        profile:{
            title:'Profile',
            SAVE:'SAVE',
            uploadInfo:[
                'Please select the picture to upload',
                'The image cannot exceed 2M',
            ]
        }
    },
    alert:{
        sucAlert:[
            'Add succeeded!',
            'Update succeeded!',
            'Delete succeeded!',
            'Operation succeeded!',
            'Exit successful!'
        ],
        failAlert:[
            'Failed to add!',
            'Modification failed!',
            'Delete failed!',
            'Operation failed!',
        ],
    },
    buyOut:{
        title:'Copyright Buyout',
        form:[
            'Author\'s Age',
            'Author\'s Gender',
            'Identification Document Type',
            'Identification Document ID',
            'PayPal',
            'PayPal email',
            'Recipient\'s Name',
            'IFSC Code',
            'IBAN Number',
            'MICR Code',
            'Guardian\'s Full Name ',
            'Guardian\'s Signature Image',],
        formRules:[
            'Fill in the Author\'s Age',
            'Fill in the Author\'s Gender',
            'Please Select Identification Document Type',
            'Fill in Identification Document ID',
            'Fill in PayPal email',
            'Fill in Recipient\'s Name',
            'Fill in IFSC Code',
            'Fill in IBAN Number',
            'Fill in MICR Code',
            'Fill in Guardian\'s Full Name ',
            'Guardian\'s Signature Image',
        ]
    },
    tips: {
        agreement: 'Please agree to the user agreement and privacy agreement first!',
        cannotBeEmpty: 'Email address cannot be empty',
        format: 'The email format is incorrect. Please check the @ symbol and domain name',
        emailLength: 'Email length cannot exceed 50 characters at most',  // 邮箱长度最多不能超过50个字符
        inputPassword: 'Please input password',
        passwordLength: 'Please enter a password length between 8-16 characters', // 密码长度请输入在8~16位之间
        passwords: 'The passwords entered twice are inconsistent. Please confirm again before entering!',
        registeredSuccessfully: 'registered successfully!',
        registerFailed: 'Email registration failed!',
        enterChineseName: 'Please enter the correct Chinese name',
        penCharacters: 'The pen name should not exceed 50 characters',
    },
}
export default en_US;
